import buildRoutes from 'ember-engines/routes';
export default buildRoutes(function () {
  this.route('accounts', function () {
    this.route('index');
    this.route('account', {
      path: ':billing_account_id'
    }, function () {
      this.route('summary', function () {
        this.route('index');
        this.route('project-detail', function () {
          this.route('index', {
            path: '/:project_id'
          });
        });
      });
      this.route('payments', {}, function () {
        this.route('index', {
          path: '/'
        });
        this.route('credit-card', function () {
          this.route('delete');
        });
        this.route('contract-activation');
      });
      this.route('contracts', {}, function () {
        this.route('list', {
          path: ''
        });
        this.route('detail', {
          path: '/:contract_id'
        });
      });
      this.route('statements', {}, function () {
        this.route('list', {
          path: ''
        });
        this.route('detail', {
          path: '/:statement_id'
        }, function () {
          this.route('project-detail', function () {
            this.route('index', {
              path: '/:project_id'
            });
          });
        });
      });
    });
  });
});